import { createSelector } from 'reselect';
import _values from 'lodash/values';
import _get from 'lodash/get';

import Entitlement from '.';

const _scopedState = (state) => state.entities[Entitlement.namespace];
const _entitlementsById = (state) => _scopedState(state).byId;

const entitlementCounts = createSelector(_entitlementsById, (e) => _values(e));
const entitlementCountById = createSelector(
  [_entitlementsById, (state, experienceId) => experienceId, (state, experienceId, promotionId) => promotionId],
  (entitlement, experienceId, promotionId) => {
    return _get(entitlement, `${experienceId}:${promotionId}`, null);
  }
);

const isLoading = (state) => _scopedState(state).isLoading;

export default {
  isLoading,
  entitlementCounts,
  entitlementCountById,
};
